/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RoutingResponseWaypoint } from "./RoutingResponseWaypoint";
import {
  RoutingResponseWaypointFromJSON,
  RoutingResponseWaypointFromJSONTyped,
  RoutingResponseWaypointToJSON,
  RoutingResponseWaypointToJSONTyped,
} from "./RoutingResponseWaypoint";
import type { RouteSummary } from "./RouteSummary";
import {
  RouteSummaryFromJSON,
  RouteSummaryFromJSONTyped,
  RouteSummaryToJSON,
  RouteSummaryToJSONTyped,
} from "./RouteSummary";
import type { RoutingLongUnits } from "./RoutingLongUnits";
import {
  RoutingLongUnitsFromJSON,
  RoutingLongUnitsFromJSONTyped,
  RoutingLongUnitsToJSON,
  RoutingLongUnitsToJSONTyped,
} from "./RoutingLongUnits";
import type { RouteLeg } from "./RouteLeg";
import {
  RouteLegFromJSON,
  RouteLegFromJSONTyped,
  RouteLegToJSON,
  RouteLegToJSONTyped,
} from "./RouteLeg";
import type { RoutingLanguages } from "./RoutingLanguages";
import {
  RoutingLanguagesFromJSON,
  RoutingLanguagesFromJSONTyped,
  RoutingLanguagesToJSON,
  RoutingLanguagesToJSONTyped,
} from "./RoutingLanguages";

/**
 *
 * @export
 * @interface RouteTrip
 */
export interface RouteTrip {
  /**
   * The response status code
   * @type {number}
   * @memberof RouteTrip
   */
  status: number;
  /**
   * The response status message
   * @type {string}
   * @memberof RouteTrip
   */
  statusMessage: string;
  /**
   *
   * @type {RoutingLongUnits}
   * @memberof RouteTrip
   */
  units: RoutingLongUnits;
  /**
   *
   * @type {RoutingLanguages}
   * @memberof RouteTrip
   */
  language: RoutingLanguages;
  /**
   *
   * @type {Array<RoutingResponseWaypoint>}
   * @memberof RouteTrip
   */
  locations: Array<RoutingResponseWaypoint>;
  /**
   *
   * @type {Array<RouteLeg>}
   * @memberof RouteTrip
   */
  legs: Array<RouteLeg>;
  /**
   *
   * @type {RouteSummary}
   * @memberof RouteTrip
   */
  summary: RouteSummary;
}

/**
 * Check if a given object implements the RouteTrip interface.
 */
export function instanceOfRouteTrip(value: object): value is RouteTrip {
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("statusMessage" in value) || value["statusMessage"] === undefined)
    return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  if (!("language" in value) || value["language"] === undefined) return false;
  if (!("locations" in value) || value["locations"] === undefined) return false;
  if (!("legs" in value) || value["legs"] === undefined) return false;
  if (!("summary" in value) || value["summary"] === undefined) return false;
  return true;
}

export function RouteTripFromJSON(json: any): RouteTrip {
  return RouteTripFromJSONTyped(json, false);
}

export function RouteTripFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RouteTrip {
  if (json == null) {
    return json;
  }
  return {
    status: json["status"],
    statusMessage: json["status_message"],
    units: RoutingLongUnitsFromJSON(json["units"]),
    language: RoutingLanguagesFromJSON(json["language"]),
    locations: (json["locations"] as Array<any>).map(
      RoutingResponseWaypointFromJSON,
    ),
    legs: (json["legs"] as Array<any>).map(RouteLegFromJSON),
    summary: RouteSummaryFromJSON(json["summary"]),
  };
}

export function RouteTripToJSON(json: any): RouteTrip {
  return RouteTripToJSONTyped(json, false);
}

export function RouteTripToJSONTyped(
  value?: RouteTrip | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    status: value["status"],
    status_message: value["statusMessage"],
    units: RoutingLongUnitsToJSON(value["units"]),
    language: RoutingLanguagesToJSON(value["language"]),
    locations: (value["locations"] as Array<any>).map(
      RoutingResponseWaypointToJSON,
    ),
    legs: (value["legs"] as Array<any>).map(RouteLegToJSON),
    summary: RouteSummaryToJSON(value["summary"]),
  };
}
